// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
// eslint-disable-next-line
import PropTypes from 'prop-types';


/*
 * Two factor code input component
 */

const styles = theme => ({
  root : {},
  codeBox : {
    display: 'flexbox',
    justifyContent: 'center',
  },
  codeDigit : {
    width: '1em',
    margin: 5,
    border: 0,
    textAlign: 'center',
    borderBottom: '2px solid white',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    ...theme.typography.h6,
    outline: 0,
  },
});


class TwoFactorCode extends Component {
  constructor(props) {
    super(props);
    this.inputRefs = [ React.createRef(),
                       React.createRef(),
                       React.createRef(),
                       React.createRef(),
                       React.createRef(),
                       React.createRef()];
  }
  state = {
    digits: ['', '', '', '', '', ''],
    focus : 0,
  }

  digitChanged = (pos, value) => {
    let digits =  [ ...this.props.digits];
    digits[pos] = value.slice(-1);
    let focus = pos;
    if (value.length > 0 && this.state.focus < 5) {
      focus = focus + 1;
    }
    
    if (this.state.focus === 5 && value.length > 0) {
        focus = undefined;
    }
    this.props.onChange(digits);
    this.setState({focus});
  }

  onBackspace = (pos) => {
    if (this.props.digits[pos].length === 0 && pos > 0) {
      this.setState({focus : pos - 1});
    }
  }
  
  componentDidUpdate() {
    if (typeof(this.state.focus) === 'number') {
      if (this.inputRefs[this.state.focus].current) {
        this.inputRefs[this.state.focus].current.focus()
      }
    } else {
      if (document.activeElement === this.inputRefs[5].current) {
        if (this.props.nextRef && this.props.nextRef.current) {
          this.props.nextRef.current.focus()
        }
      }
    }
  }

  render() {
    const { classes, digits } = this.props;
    
    return(
      <React.Fragment>
        <div className={classes.codeBox}>
          <input autoFocus className={classes.codeDigit}
                 ref={this.inputRefs[0]}
                 onKeyDown={(event) => {
                   if (event.which === 8) {
                   this.onBackspace(0);
                 }}}
                 type='text'
                 autoComplete='new-password'
                 onChange={(event) => this.digitChanged(0, event.target.value)}
                 value={digits[0]} />
          <input className={classes.codeDigit}
                 ref={this.inputRefs[1]}
                 onKeyDown={(event) => {
                   if (event.which === 8) {
                   this.onBackspace(1);
                 }}}
                 type='text'
                 autoComplete='new-password'
                 onChange={(event) => this.digitChanged(1, event.target.value)}
                 value={digits[1]} />
          <input className={classes.codeDigit}
                 ref={this.inputRefs[2]}
                 onKeyDown={(event) => {
                   if (event.which === 8) {
                   this.onBackspace(2);
                 }}}
                 type='text'
                 autoComplete='new-password'
                 onChange={(event) => this.digitChanged(2, event.target.value)}
                 value={digits[2]} />
          <input className={classes.codeDigit}
                 ref={this.inputRefs[3]}
                 onKeyDown={(event) => {
                   if (event.which === 8) {
                   this.onBackspace(3);
                 }}}
                 type='text'
                 autoComplete='new-password'
                 onChange={(event) => this.digitChanged(3, event.target.value)}
                 value={digits[3]} />
          <input className={classes.codeDigit}
                 ref={this.inputRefs[4]}
                 onKeyDown={(event) => {
                   if (event.which === 8) {
                   this.onBackspace(4);
                 }}}
                 type='text'
                 autoComplete='new-password'
                 onChange={(event) => this.digitChanged(4, event.target.value)}
                 value={digits[4]} />
          <input className={classes.codeDigit}
                 ref={this.inputRefs[5]}
                 onKeyDown={(event) => {
                   if (event.which === 8) {
                     this.onBackspace(5);
                   }}}
          
                 type='text'
                 autoComplete='new-password'
                 onChange={(event) => this.digitChanged(5, event.target.value)}
                 value={digits[5]} />
        </div>
      </React.Fragment>);
  }
}

TwoFactorCode.propTypes = {
  digits : PropTypes.array.isRequired,
  onChange : PropTypes.func,
  nextRef : PropTypes.object,
}

TwoFactorCode.defaultProps = {
}


export default withStyles(styles)(TwoFactorCode);

